export default {
    storage: {
        storageMembership: '保管會員',
        title: '保管會員 | 安全遺囑保管',
        description: '將您的遺囑正本及遺產規劃文件存放於防火、防水及防破壞的保險箱，並在需要時提供取回支援。',
        keywords: '遺囑保管, 保管會員, 安全遺囑保管, 遺產規劃文件',
        heading: '安全遺囑保管',
        subHeading: '為您的遺囑正本及遺產規劃文件提供安全保管，並為您及您的遺囑執行人提供清晰的取回支援。',
        storageMem: '每年{{price}}',
        benefitsHeading: '為何將遺囑交由我們保管？',
        benefitsBody: '遺囑正本必須在需要時能夠被找到、被信任並提交使用。保管會員會妥善保護您的文件，並為遺囑執行人提供清晰的取回流程。',
        benefitKnownLocation: '清楚知道文件位置',
        benefitKnownLocationBody: '您的遺囑執行人無需翻找抽屜、文件夾、銀行保險箱或舊地址，便可知道遺囑正本的保管安排。',
        benefitTamperProof: '防止文件被篡改',
        benefitTamperProofBody: '安全保管有助保持遺囑正本的可信度，避免文件被更改、移走或替換。',
        benefitDamageProtection: '避免日常損壞',
        benefitDamageProtectionBody: '讓遺囑遠離火災、水浸、摺曲、褪色、搬遷遺失或被意外棄置等風險。',
        benefitExecutorAccess: '清晰取回支援',
        benefitExecutorAccessBody: '在需要時，您或經核實的遺囑執行人可透過清晰流程申請取回文件。',
        processHeading: '保管會員流程',
        process1: '加入保管會員',
        process1Body: '您可在購買遺囑服務時，或在完成遺囑後從帳戶頁面加入保管會員。',
        process2: '寄送文件給我們',
        process2Body: '我們會提供寄送遺囑正本及相關遺產規劃文件的指引，以便為您妥善保管。',
        process3: '安全保管及記錄',
        process3Body: '您的文件會存放於安全保險箱，我們亦會每年提醒您文件正由我們保管。',
        process4: '需要時取回',
        process4Body: '您或經核實的遺囑執行人可在需要遺囑正本時申請取回文件。',
        executorHeading: '遺囑執行人如何取回遺囑',
        executorBody: '保管會員的一大優點，是您的遺囑執行人無需獨自摸索取回流程。NobleWills 會提供清晰指引，讓執行人知道需要準備甚麼、如何取回遺囑正本，以及如何處理遺囑認證流程。',
        executorStep1: '執行人聯絡我們',
        executorStep1Body: '當需要遺囑正本時，您的遺囑執行人可直接聯絡 NobleWills，而無需在沒有方向的情況下尋找文件。',
        executorStep2: '我們說明所需資料',
        executorStep2Body: '我們會指引執行人準備核實身份及申請所需的資料和文件，包括身份證明及適用情況下的死亡證明。',
        executorStep3: '核實及取出文件',
        executorStep3Body: '申請經核實後，我們會取出已保管的遺囑，並確認合適的交付或領取安排。',
        executorStep4: '遺囑認證指引',
        executorStep4Body: '您的遺囑執行人會獲得有關遺囑認證流程的實用指引，包括遺囑正本在後續遺產管理中可能如何使用。',
        included1: '專業級文件保管服務 - 防火、防水、防破壞的安全保險箱',
        included2: '您可按需要申請取回存放文件',
        included3: '年度文件保管提醒服務',
        included4: '保管您的遺囑、願望信及資產清單',
    },
};
